import inputData from './inputData/e-commerce-lead-capture-quiz';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'e-commerce-lead-capture-quiz',
  title: 'E-commerce Lead Capture Quiz',
  description: 'Grow your email list by engaging shoppers with a quick, interactive quiz designed to turn visitors into leads.',
  image: '/images/templates/e-commerce-lead-capture-quiz.png',
  tags: ['sales', 'make-sales', 'lead-generation'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

